// Scheda cliente: stato dell'area clienti (app) e azioni dello studio.
// Regola: attiva in automatico se il cellulare/email è solo di questo cliente; se è condiviso con altri
// clienti va attivata a mano; lo studio può sempre disattivarla.
import React, { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Button } from '../ui/button';

const API = `${process.env.REACT_APP_BACKEND_URL}/api/area-clienti-studio`;

export default function AreaClientiStato({ cliente }) {
  const [stato, setStato] = useState(null);
  const [promemoria, setPromemoria] = useState([]);
  const carica = useCallback(async () => {
    try { setStato((await axios.get(`${API}/stato/${cliente.id}`)).data); } catch (_) { setStato(null); }
    try { setPromemoria((await axios.get(`${API}/promemoria/${cliente.id}`)).data.promemoria); } catch (_) { setPromemoria([]); }
  }, [cliente.id]);
  const promemoriaOnOff = async (p, attivo) => {
    try { await axios.put(`${API}/promemoria/${encodeURIComponent(p.id)}`, { attivo }); carica(); toast.success(attivo ? 'Promemoria riattivato' : 'Promemoria disattivato'); }
    catch (_) { toast.error('Operazione non riuscita'); }
  };
  useEffect(() => { carica(); }, [carica, cliente.phone, cliente.email]);

  const imposta = async (attiva) => {
    if (attiva && !window.confirm(`Attivare a mano l'area clienti per ${cliente.last_name} ${cliente.first_name}?\n\nIl cellulare o l'email sono condivisi con altri clienti: attivala solo se appartengono davvero a questo cliente.`)) return;
    try {
      await axios.put(`${API}/attivazione/${cliente.id}`, { attiva });
      toast.success(attiva ? 'Area clienti attivata' : 'Area clienti disattivata');
      carica();
    } catch (err) { toast.error(err.response?.data?.detail || 'Operazione non riuscita'); }
  };
  const codice = async () => {
    try {
      const r = (await axios.post(`${API}/codice/${cliente.id}`)).data;
      window.alert(`Codice di accesso per l'area clienti: ${r.codice}\n\n${r.con_email ? 'Email' : 'Cellulare'}: ${r.cellulare}\nValido ${r.valido_minuti} minuti, una sola volta.\n\nIl cliente apre https://clienti.crm-jv.com, sceglie ${r.con_email ? '"Via email" e scrive la sua email' : '"Via SMS" e scrive il suo cellulare'}, tocca "Ho già un codice" e inserisce questo codice.`);
    } catch (err) { toast.error(err.response?.data?.detail || 'Codice non generato'); }
  };

  const togliImpronta = async () => {
    if (!window.confirm("Togliere l'accesso con impronta/Face ID da tutti i telefoni del cliente?\n\nAl prossimo accesso dovrà usare il codice SMS o email.")) return;
    try { const r = (await axios.delete(`${API}/biometria/${cliente.id}`)).data; toast.success(`Impronta tolta da ${r.tolti} telefono/i`); carica(); }
    catch (_) { toast.error('Operazione non riuscita'); }
  };

  if (!stato) return <p className="text-sm text-slate-400">…</p>;
  return (
    <div className="space-y-2">
    <div className="flex flex-wrap items-center gap-2">
      <span className={`font-medium ${stato.attiva ? 'text-emerald-700' : 'text-amber-700'}`}>{stato.attiva ? 'Attiva' : 'Non attiva'}</span>
      <span className="text-xs text-slate-500">({stato.motivo})</span>
      {stato.attiva ? (
        <>
          <Button type="button" size="sm" variant="outline" className="h-7 text-xs" onClick={codice}>Codice di accesso</Button>
          <Button type="button" size="sm" variant="outline" className="h-7 text-xs text-red-600" onClick={() => imposta(false)}>Disattiva</Button>
        </>
      ) : (
        <Button type="button" size="sm" variant="outline" className="h-7 text-xs" onClick={() => imposta(true)}>Attiva a mano</Button>
      )}
    </div>
    {(stato.consensi || []).length === 0
      ? <div className="text-xs text-slate-500">Privacy: il cliente non è ancora entrato nell'area clienti (nessun consenso registrato).</div>
      : stato.consensi.map((c) => (
        <div key={c.contatto} className="text-xs text-slate-600">
          Privacy ({c.contatto}): informativa accettata il {c.quando}{c.attuale ? '' : ' (versione vecchia, da rinnovare al prossimo accesso)'}
          {' · '}news <b>{c.news ? 'SI' : 'NO'}</b> · promemoria <b>{c.promemoria ? 'SI' : 'NO'}</b>
        </div>
      ))}
    {stato.biometria > 0 && (
      <div className="flex flex-wrap items-center gap-2 text-xs text-slate-600">
        Accesso con impronta/Face ID attivo su {stato.biometria} telefono/i
        <Button type="button" size="sm" variant="outline" className="h-6 text-xs" onClick={togliImpronta}>Togli (telefono perso)</Button>
      </div>
    )}
    {promemoria.map((p) => (
      <div key={p.id} className="flex flex-wrap items-center gap-2 text-sm">
        <span className={p.spento ? 'text-slate-400 line-through' : 'text-slate-700'}>Promemoria {p.servizio}: {p.testo.split('.')[0]}</span>
        {p.spento && <span className="text-xs text-slate-500">(spento {p.spento.da === 'cliente' ? 'dal cliente' : 'dallo studio'} il {p.spento.quando})</span>}
        <Button type="button" size="sm" variant="outline" className="h-6 text-xs" onClick={() => promemoriaOnOff(p, !!p.spento)}>
          {p.spento ? 'Riattiva' : 'Disattiva (già fatto)'}
        </Button>
      </div>
    ))}
    </div>
  );
}
